import { faAward } from '@fortawesome/free-solid-svg-icons';
import './styles/award-info-style.css';
import { Col, Row } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { generateColors } from '../../../../../utils/colorUtilsClientInfo';
import MedalIcon from '../../../../../assets/images/ic_award.png';

const AwardInfoPanel = ({ colorSeed, award }) => {
  const colours = generateColors(colorSeed);
  return (
    <Row className="awardInfoContainer mt-1 d-flex ">
      <Col xs={2} sm={2} lg={1} className="d-flex justify-content-center ">
        <span className="rounded-span" style={{ backgroundColor: colours.backgroundColor, color: colours.color }}>
          <img src={MedalIcon} alt='medal icon' />
        </span>
      </Col>
      <Col xs={10} sm={10} lg={11}>
        <Row>
          <Col xs={12}>
            <span className="title pt-1">{_.get(award, 'title')}</span>
            {_.get(award, 'providedBy') && (
              <span className="sub-title"> from {_.get(award, 'providedBy')}</span>
            )}
          </Col>
        </Row>
        <Row>
          <Col xs={12}>
            <span className="sub-title1"> {_.get(award, 'issueYear')} </span>
          </Col>
        </Row>
      </Col>
    </Row>
  );
};

export default AwardInfoPanel;
